/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EsercentiStatsDTO } from '../model/esercentiStatsDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { NuovaPraticaResultDTO } from '../model/nuovaPraticaResultDTO';
import { PagePraticaEsercenteViewResponseNoTransactions } from '../model/pagePraticaEsercenteViewResponseNoTransactions';
import { PraticaEsercente } from '../model/praticaEsercente';
import { PraticaEsercenteDTO } from '../model/praticaEsercenteDTO';
import { PraticaEsercenteViewResponseNoTransactions } from '../model/praticaEsercenteViewResponseNoTransactions';
import { RichiestaPraticaEsercenteStatus } from '../model/richiestaPraticaEsercenteStatus';
import { UpdateStatoPraticaEsercenteDTO } from '../model/updateStatoPraticaEsercenteDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PraticheEsercentiControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Consente di aggiungere una nuova richiesta da parte di un esercente per una determinata pratica
     * 
     * @param id_slug_comune 
     * @param praticaEsercente 
     * @param documentoAnagrafica1 
     * @param documentoAnagrafica2 
     * @param documentoAnagrafica3 
     * @param documentoAnagrafica4 
     * @param documentoAnagrafica5 
     * @param documento1 
     * @param documento2 
     * @param documento3 
     * @param documento4 
     * @param documento5 
     * @param documento6 
     * @param documento7 
     * @param documento8 
     * @param documento9 
     * @param documento10 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addPraticaEsercenteForm(id_slug_comune: string, praticaEsercente?: PraticaEsercenteDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, observe?: 'body', reportProgress?: boolean): Observable<NuovaPraticaResultDTO>;
    public addPraticaEsercenteForm(id_slug_comune: string, praticaEsercente?: PraticaEsercenteDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NuovaPraticaResultDTO>>;
    public addPraticaEsercenteForm(id_slug_comune: string, praticaEsercente?: PraticaEsercenteDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NuovaPraticaResultDTO>>;
    public addPraticaEsercenteForm(id_slug_comune: string, praticaEsercente?: PraticaEsercenteDTO, documentoAnagrafica1?: Blob, documentoAnagrafica2?: Blob, documentoAnagrafica3?: Blob, documentoAnagrafica4?: Blob, documentoAnagrafica5?: Blob, documento1?: Blob, documento2?: Blob, documento3?: Blob, documento4?: Blob, documento5?: Blob, documento6?: Blob, documento7?: Blob, documento8?: Blob, documento9?: Blob, documento10?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addPraticaEsercente.');
        }

















        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (praticaEsercente !== undefined) {
            formParams = (formParams as FormData).append('praticaEsercente', new Blob([JSON.stringify(praticaEsercente)], { type: 'application/json'})) as any || formParams;
        }
        if (documentoAnagrafica1 !== undefined) {
            formParams = formParams.append('documentoAnagrafica1', <any>documentoAnagrafica1) as any || formParams;
        }
        if (documentoAnagrafica2 !== undefined) {
            formParams = formParams.append('documentoAnagrafica2', <any>documentoAnagrafica2) as any || formParams;
        }
        if (documentoAnagrafica3 !== undefined) {
            formParams = formParams.append('documentoAnagrafica3', <any>documentoAnagrafica3) as any || formParams;
        }
        if (documentoAnagrafica4 !== undefined) {
            formParams = formParams.append('documentoAnagrafica4', <any>documentoAnagrafica4) as any || formParams;
        }
        if (documentoAnagrafica5 !== undefined) {
            formParams = formParams.append('documentoAnagrafica5', <any>documentoAnagrafica5) as any || formParams;
        }
        if (documento1 !== undefined) {
            formParams = formParams.append('documento1', <any>documento1) as any || formParams;
        }
        if (documento2 !== undefined) {
            formParams = formParams.append('documento2', <any>documento2) as any || formParams;
        }
        if (documento3 !== undefined) {
            formParams = formParams.append('documento3', <any>documento3) as any || formParams;
        }
        if (documento4 !== undefined) {
            formParams = formParams.append('documento4', <any>documento4) as any || formParams;
        }
        if (documento5 !== undefined) {
            formParams = formParams.append('documento5', <any>documento5) as any || formParams;
        }
        if (documento6 !== undefined) {
            formParams = formParams.append('documento6', <any>documento6) as any || formParams;
        }
        if (documento7 !== undefined) {
            formParams = formParams.append('documento7', <any>documento7) as any || formParams;
        }
        if (documento8 !== undefined) {
            formParams = formParams.append('documento8', <any>documento8) as any || formParams;
        }
        if (documento9 !== undefined) {
            formParams = formParams.append('documento9', <any>documento9) as any || formParams;
        }
        if (documento10 !== undefined) {
            formParams = formParams.append('documento10', <any>documento10) as any || formParams;
        }

        return this.httpClient.request<NuovaPraticaResultDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricercare le pratiche esercenti
     * 
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param codice_pratica 
     * @param status 
     * @param nome 
     * @param cognome 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll3(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaEsercenteStatus, nome?: string, cognome?: string, observe?: 'body', reportProgress?: boolean): Observable<PagePraticaEsercenteViewResponseNoTransactions>;
    public getAll3(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaEsercenteStatus, nome?: string, cognome?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PagePraticaEsercenteViewResponseNoTransactions>>;
    public getAll3(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaEsercenteStatus, nome?: string, cognome?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PagePraticaEsercenteViewResponseNoTransactions>>;
    public getAll3(id_slug_comune: string, page: number, size?: number, codice_pratica?: string, status?: RichiestaPraticaEsercenteStatus, nome?: string, cognome?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAll3.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getAll3.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (codice_pratica !== undefined && codice_pratica !== null) {
            queryParameters = queryParameters.set('codice_pratica', <any>codice_pratica);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (nome !== undefined && nome !== null) {
            queryParameters = queryParameters.set('nome', <any>nome);
        }
        if (cognome !== undefined && cognome !== null) {
            queryParameters = queryParameters.set('cognome', <any>cognome);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PagePraticaEsercenteViewResponseNoTransactions>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di scaricare la convenzione da firmare per la pratica specificata
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConvenzionePraticaEsercente(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getConvenzionePraticaEsercente(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getConvenzionePraticaEsercente(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getConvenzionePraticaEsercente(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getConvenzionePraticaEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getConvenzionePraticaEsercente.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}/convenzione`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di scaricare un documento allegato alla pratica esercente
     * @param id_slug_comune 
     * @param codicePratica 
     * @param nomeFile 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDocumentoPraticaEsercente(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getDocumentoPraticaEsercente(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getDocumentoPraticaEsercente(id_slug_comune: string, codicePratica: string, nomeFile: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getDocumentoPraticaEsercente(id_slug_comune: string, codicePratica: string, nomeFile: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getDocumentoPraticaEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getDocumentoPraticaEsercente.');
        }

        if (nomeFile === null || nomeFile === undefined) {
            throw new Error('Required parameter nomeFile was null or undefined when calling getDocumentoPraticaEsercente.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nomeFile !== undefined && nomeFile !== null) {
            queryParameters = queryParameters.set('nomeFile', <any>nomeFile);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}/documento`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricevere il dettaglio di una pratica esercente a partire dal codice pratica
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param noNegozi 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPraticaEsercente(id_slug_comune: string, codicePratica: string, noNegozi?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PraticaEsercenteViewResponseNoTransactions>;
    public getPraticaEsercente(id_slug_comune: string, codicePratica: string, noNegozi?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PraticaEsercenteViewResponseNoTransactions>>;
    public getPraticaEsercente(id_slug_comune: string, codicePratica: string, noNegozi?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PraticaEsercenteViewResponseNoTransactions>>;
    public getPraticaEsercente(id_slug_comune: string, codicePratica: string, noNegozi?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPraticaEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPraticaEsercente.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (noNegozi !== undefined && noNegozi !== null) {
            queryParameters = queryParameters.set('noNegozi', <any>noNegozi);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PraticaEsercenteViewResponseNoTransactions>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di visualizzare le statistiche relative allo stato delle domande sottomesse
     * 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPraticheEsercentiStats(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<EsercentiStatsDTO>;
    public getPraticheEsercentiStats(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EsercentiStatsDTO>>;
    public getPraticheEsercentiStats(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EsercentiStatsDTO>>;
    public getPraticheEsercentiStats(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPraticheEsercentiStats.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EsercentiStatsDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/stats/get`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di ricevere la lista delle pratiche esercenti in conflitto con quella richiesta (per CF del richiedente)
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPraticheInConflitto1(id_slug_comune: string, codicePratica: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PraticaEsercenteViewResponseNoTransactions>>;
    public getPraticheInConflitto1(id_slug_comune: string, codicePratica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PraticaEsercenteViewResponseNoTransactions>>>;
    public getPraticheInConflitto1(id_slug_comune: string, codicePratica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PraticaEsercenteViewResponseNoTransactions>>>;
    public getPraticheInConflitto1(id_slug_comune: string, codicePratica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getPraticheInConflitto1.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling getPraticheInConflitto1.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<PraticaEsercenteViewResponseNoTransactions>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}/conflitti`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di fare il lock o l&#x27;unlock di una pratica esercente. Se il parametro unlock non viene passato viene impostato di default a true
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param unlock 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public lockUnlockPratica1(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PraticaEsercenteViewResponseNoTransactions>;
    public lockUnlockPratica1(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PraticaEsercenteViewResponseNoTransactions>>;
    public lockUnlockPratica1(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PraticaEsercenteViewResponseNoTransactions>>;
    public lockUnlockPratica1(id_slug_comune: string, codicePratica: string, unlock?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling lockUnlockPratica1.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling lockUnlockPratica1.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (unlock !== undefined && unlock !== null) {
            queryParameters = queryParameters.set('unlock', <any>unlock);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PraticaEsercenteViewResponseNoTransactions>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}/unlock`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiornare lo stato di una pratica esercente. Opzionalmente è possibile passare una nota ed il file relativo alla convenzione (per gli stati che lo richiedono)
     * 
     * @param id_slug_comune 
     * @param codicePratica 
     * @param convenzione 
     * @param updateStatoPraticaEsercenteDTO 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStatoPraticaEsercenteForm(id_slug_comune: string, codicePratica: string, convenzione?: Blob, updateStatoPraticaEsercenteDTO?: UpdateStatoPraticaEsercenteDTO, observe?: 'body', reportProgress?: boolean): Observable<PraticaEsercente>;
    public updateStatoPraticaEsercenteForm(id_slug_comune: string, codicePratica: string, convenzione?: Blob, updateStatoPraticaEsercenteDTO?: UpdateStatoPraticaEsercenteDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PraticaEsercente>>;
    public updateStatoPraticaEsercenteForm(id_slug_comune: string, codicePratica: string, convenzione?: Blob, updateStatoPraticaEsercenteDTO?: UpdateStatoPraticaEsercenteDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PraticaEsercente>>;
    public updateStatoPraticaEsercenteForm(id_slug_comune: string, codicePratica: string, convenzione?: Blob, updateStatoPraticaEsercenteDTO?: UpdateStatoPraticaEsercenteDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateStatoPraticaEsercente.');
        }

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling updateStatoPraticaEsercente.');
        }



        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (convenzione !== undefined) {
            formParams = formParams.append('convenzione', <any>convenzione) as any || formParams;
        }
        if (updateStatoPraticaEsercenteDTO !== undefined) {
            formParams = formParams.append('updateStatoPraticaEsercenteDTO', <any>updateStatoPraticaEsercenteDTO) as any || formParams;
        }

        return this.httpClient.request<PraticaEsercente>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/pratiche-esercenti/${encodeURIComponent(String(codicePratica))}/updateStato`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
